//AUTH
export const GET_USER_DATA = "GET_USER_DATA";
export const GET_USER_DATA_SUCCESS = "GET_USER_DATA_SUCCESS";
export const GET_USER_DATA_ERROR = "GET_USER_DATA_ERROR";
export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const LOGOUT_USER_ERROR = "LOGOUT_USER_ERROR";
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_ERROR = "LOGIN_USER_ERROR";
export const UPDATE_PROFILE_USER = "UPDATE_PROFILE_USER";
export const UPDATE_PROFILE_USER_SUCCESS = "UPDATE_PROFILE_USER_SUCCESS";
export const UPDATE_PROFILE_USER_ERROR = "UPDATE_PROFILE_USER_ERROR";
export const CHANGE_PASS_USER = "CHANGE_PASS_USER";
export const CHANGE_PASS_USER_SUCCESS = "CHANGE_PASS_USER_SUCCESS";
export const CHANGE_PASS_USER_ERROR = "CHANGE_PASS_USER_ERROR";
export const SET_OBJECT = 'SET_OBJECT';
export const SET_OBJECT_SUCCESS = 'SET_OBJECT_SUCCESS';

//ACTS
export const LIST_ACTS = "LIST_ACTS";
export const LIST_ACTS_SUCCESS = "LIST_ACTS_SUCCESS";
export const LIST_ACTS_ERROR = "LIST_ACTS_ERROR";
export const ADD_ACTS = "ADD_ACTS";
export const SAVE_ACTS = "SAVE_ACTS";
export const SAVE_ACTS_SUCCESS = "SAVE_ACTS_SUCCESS";
export const SAVE_ACTS_ERROR = "SAVE_ACTS_ERROR";
export const EDIT_ACTS = "EDIT_ACTS";
export const UPDATE_ACTS = "UPDATE_ACTS";
export const UPDATE_ACTS_SUCCESS = "UPDATE_ACTS_SUCCESS";
export const UPDATE_ACTS_ERROR = "UPDATE_ACTS_ERROR";
export const MIGRATE_ACTS = "MIGRATE_ACTS";
export const MIGRATE_ACTS_SUCCESS = "MIGRATE_ACTS_SUCCESS";
export const MIGRATE_ACTS_ERROR = "MIGRATE_ACTS_ERROR";
export const DELETE_ACTS = "DELETE_ACTS";
export const DELETE_ACTS_SUCCESS = "DELETE_ACTS_SUCCESS";
export const DELETE_ACTS_ERROR = "DELETE_ACTS_ERROR";

//AUDIENCES
export const LIST_AUDIENCES = "LIST_AUDIENCES";
export const LIST_AUDIENCES_SUCCESS = "LIST_AUDIENCES_SUCCESS";
export const LIST_AUDIENCES_ERROR = "LIST_AUDIENCES_ERROR";
export const WORK_LIST_AUDIENCES = "WORK_LIST_AUDIENCES";
export const WORK_LIST_AUDIENCES_SUCCESS = "WORK_LIST_AUDIENCES_SUCCESS";
export const WORK_LIST_AUDIENCES_ERROR = "WORK_LIST_AUDIENCES_ERROR";
export const ADD_AUDIENCES = "ADD_AUDIENCES";
export const SAVE_AUDIENCES = "SAVE_AUDIENCES";
export const SAVE_AUDIENCES_SUCCESS = "SAVE_AUDIENCES_SUCCESS";
export const SAVE_AUDIENCES_ERROR = "SAVE_AUDIENCES_ERROR";
export const EDIT_AUDIENCES = "EDIT_AUDIENCES";
export const UPDATE_AUDIENCES = "UPDATE_AUDIENCES";
export const UPDATE_AUDIENCES_SUCCESS = "UPDATE_AUDIENCES_SUCCESS";
export const UPDATE_AUDIENCES_ERROR = "UPDATE_AUDIENCES_ERROR";
export const DELETE_AUDIENCES = "DELETE_AUDIENCES";
export const DELETE_AUDIENCES_SUCCESS = "DELETE_AUDIENCES_SUCCESS";
export const DELETE_AUDIENCES_ERROR = "DELETE_AUDIENCES_ERROR";

export const APPROVE_AUDIENCE = "APPROVE_AUDIENCE";
export const APPROVE_AUDIENCE_SUCCESS = "APPROVE_AUDIENCE_SUCCESS";
export const APPROVE_AUDIENCE_ERROR = "APPROVE_AUDIENCE_ERROR";
export const CANCEL_AUDIENCE = "CANCEL_AUDIENCE";
export const CANCEL_AUDIENCE_SUCCESS = "CANCEL_AUDIENCE_SUCCESS";
export const CANCEL_AUDIENCE_ERROR = "CANCEL_AUDIENCE_ERROR";
export const GET_AUDIENCE = "GET_AUDIENCE";
export const GET_AUDIENCE_SUCCESS = "GET_AUDIENCE_SUCCESS";
export const GET_AUDIENCE_ERROR = "GET_AUDIENCE_ERROR";
export const REJECT_AUDIENCE = "REJECT_AUDIENCE";
export const REJECT_AUDIENCE_SUCCESS = "REJECT_AUDIENCE_SUCCESS";
export const REJECT_AUDIENCE_ERROR = "REJECT_AUDIENCE_ERROR";
export const RESERVE_AUDIENCE = "RESERVE_AUDIENCE";
export const RESERVE_AUDIENCE_SUCCESS = "RESERVE_AUDIENCE_SUCCESS";
export const RESERVE_AUDIENCE_ERROR = "RESERVE_AUDIENCE_ERROR";
export const REVOKE_AUDIENCE = "REVOKE_AUDIENCE";
export const REVOKE_AUDIENCE_SUCCESS = "REVOKE_AUDIENCE_SUCCESS";
export const REVOKE_AUDIENCE_ERROR = "REVOKE_AUDIENCE_ERROR";

export const SAVE_ACCUSED_RESULT = "SAVE_ACCUSED_RESULT";
export const SAVE_ACCUSED_RESULT_SUCCESS = "SAVE_ACCUSED_RESULT_SUCCESS";
export const SAVE_ACCUSED_RESULT_ERROR = "SAVE_ACCUSED_RESULT_ERROR";

export const AGENDATE_AUDIENCES = "AGENDATE_AUDIENCES";
export const AGENDATE_AUDIENCES_SUCCESS = "AGENDATE_AUDIENCES_SUCCESS";
export const AGENDATE_AUDIENCES_ERROR = "AGENDATE_AUDIENCES_ERROR";

export const ANULATE_AUDIENCE = "ANULATE_AUDIENCE";
export const ANULATE_AUDIENCE_SUCCESS = "ANULATE_AUDIENCE_SUCCESS";
export const ANULATE_AUDIENCE_ERROR = "ANULATE_AUDIENCE_ERROR";

export const ANULATE_ACCUSED_RESULT = "ANULATE_ACCUSED_RESULT";
export const ANULATE_ACCUSED_RESULT_SUCCESS = "ANULATE_ACCUSED_RESULT_SUCCESS";
export const ANULATE_ACCUSED_RESULT_ERROR = "ANULATE_ACCUSED_RESULT_ERROR";

export const CLONE_AUDIENCE = "CLONE_AUDIENCE";
export const CLONE_AUDIENCE_SUCCESS = "CLONE_AUDIENCE_SUCCESS";
export const CLONE_AUDIENCE_ERROR = "CLONE_AUDIENCE_ERROR";

export const FINALIZE_AUDIENCE = "FINALIZE_AUDIENCE";
export const FINALIZE_AUDIENCE_SUCCESS = "FINALIZE_AUDIENCE_SUCCESS";
export const FINALIZE_AUDIENCE_ERROR = "FINALIZE_AUDIENCE_ERROR";

export const ROLLBACK_AUDIENCE = "ROLLBACK_AUDIENCE";
export const ROLLBACK_AUDIENCE_SUCCESS = "ROLLBACK_AUDIENCE_SUCCESS";
export const ROLLBACK_AUDIENCE_ERROR = "ROLLBACK_AUDIENCE_ERROR";

export const UPDATE_ACCUSED = "UPDATE_ACCUSED";
export const UPDATE_ACCUSED_SUCCESS = "UPDATE_ACCUSED_SUCCESS";
export const UPDATE_ACCUSED_ERROR = "UPDATE_ACCUSED_ERROR";

export const UPDATE_CANCELLATION = "UPDATE_CANCELLATION";
export const UPDATE_CANCELLATION_SUCCESS = "UPDATE_CANCELLATION_SUCCESS";
export const UPDATE_CANCELLATION_ERROR = "UPDATE_CANCELLATION_ERROR";

export const UPDATE_OFIJU = "UPDATE_OFIJU";
export const UPDATE_OFIJU_SUCCESS = "UPDATE_OFIJU_SUCCESS";
export const UPDATE_OFIJU_ERROR = "UPDATE_OFIJU_ERROR";

export const UPDATE_OPERATOR = "UPDATE_OPERATOR";
export const UPDATE_OPERATOR_SUCCESS = "UPDATE_OPERATOR_SUCCESS";
export const UPDATE_OPERATOR_ERROR = "UPDATE_OPERATOR_ERROR";

export const UPDATE_PROCEEDING = "UPDATE_PROCEEDING";
export const UPDATE_PROCEEDING_SUCCESS = "UPDATE_PROCEEDING_SUCCESS";
export const UPDATE_PROCEEDING_ERROR = "UPDATE_PROCEEDING_ERROR";

export const UPDATE_PROSECUTOR = "UPDATE_PROSECUTOR";
export const UPDATE_PROSECUTOR_SUCCESS = "UPDATE_PROSECUTOR_SUCCESS";
export const UPDATE_PROSECUTOR_ERROR = "UPDATE_PROSECUTOR_ERROR";

export const UPDATE_SALA = "UPDATE_SALA";
export const UPDATE_SALA_SUCCESS = "UPDATE_SALA_SUCCESS";
export const UPDATE_SALA_ERROR = "UPDATE_SALA_ERROR";

export const UPDATE_SCHEDULED_END = "UPDATE_SCHEDULED_END";
export const UPDATE_SCHEDULED_END_SUCCESS = "UPDATE_SCHEDULED_END_SUCCESS";
export const UPDATE_SCHEDULED_END_ERROR = "UPDATE_SCHEDULED_END_ERROR";

export const UPDATE_SESSION_URL = "UPDATE_SESSION_URL";
export const UPDATE_SESSION_URL_SUCCESS = "UPDATE_SESSION_URL_SUCCESS";
export const UPDATE_SESSION_URL_ERROR = "UPDATE_SESSION_URL_ERROR";

export const UPDATE_VICTIM = "UPDATE_VICTIM";
export const UPDATE_VICTIM_SUCCESS = "UPDATE_VICTIM_SUCCESS";
export const UPDATE_VICTIM_ERROR = "UPDATE_VICTIM_ERROR";

//AUDIENCIA CATEGORIAS
export const LIST_AUDIENCE_CATEGORIES = "LIST_AUDIENCE_CATEGORIES";
export const LIST_AUDIENCE_CATEGORIES_SUCCESS = "LIST_AUDIENCE_CATEGORIES_SUCCESS";
export const LIST_AUDIENCE_CATEGORIES_ERROR = "LIST_AUDIENCE_CATEGORIES_ERROR";
export const ADD_AUDIENCE_CATEGORIES = "ADD_AUDIENCE_CATEGORIES";
export const SAVE_AUDIENCE_CATEGORIES = "SAVE_AUDIENCE_CATEGORIES";
export const SAVE_AUDIENCE_CATEGORIES_SUCCESS = "SAVE_AUDIENCE_CATEGORIES_SUCCESS";
export const SAVE_AUDIENCE_CATEGORIES_ERROR = "SAVE_AUDIENCE_CATEGORIES_ERROR";
export const EDIT_AUDIENCE_CATEGORIES = "EDIT_AUDIENCE_CATEGORIES";
export const UPDATE_AUDIENCE_CATEGORIES = "UPDATE_AUDIENCE_CATEGORIES";
export const UPDATE_AUDIENCE_CATEGORIES_SUCCESS = "UPDATE_AUDIENCE_CATEGORIES_SUCCESS";
export const UPDATE_AUDIENCE_CATEGORIES_ERROR = "UPDATE_AUDIENCE_CATEGORIES_ERROR";
export const DELETE_AUDIENCE_CATEGORIES = "DELETE_AUDIENCE_CATEGORIES";
export const DELETE_AUDIENCE_CATEGORIES_SUCCESS = "DELETE_AUDIENCE_CATEGORIES_SUCCESS";
export const DELETE_AUDIENCE_CATEGORIES_ERROR = "DELETE_AUDIENCE_CATEGORIES_ERROR";

//AUDIENCIA MOTIVOS
export const LIST_AUDIENCE_MOTIVES = "LIST_AUDIENCE_MOTIVES";
export const LIST_AUDIENCE_MOTIVES_SUCCESS = "LIST_AUDIENCE_MOTIVES_SUCCESS";
export const LIST_AUDIENCE_MOTIVES_ERROR = "LIST_AUDIENCE_MOTIVES_ERROR";
export const ADD_AUDIENCE_MOTIVES = "ADD_AUDIENCE_MOTIVES";
export const SAVE_AUDIENCE_MOTIVES = "SAVE_AUDIENCE_MOTIVES";
export const SAVE_AUDIENCE_MOTIVES_SUCCESS = "SAVE_AUDIENCE_MOTIVES_SUCCESS";
export const SAVE_AUDIENCE_MOTIVES_ERROR = "SAVE_AUDIENCE_MOTIVES_ERROR";
export const EDIT_AUDIENCE_MOTIVES = "EDIT_AUDIENCE_MOTIVES";
export const UPDATE_AUDIENCE_MOTIVES = "UPDATE_AUDIENCE_MOTIVES";
export const UPDATE_AUDIENCE_MOTIVES_SUCCESS = "UPDATE_AUDIENCE_MOTIVES_SUCCESS";
export const UPDATE_AUDIENCE_MOTIVES_ERROR = "UPDATE_AUDIENCE_MOTIVES_ERROR";
export const DELETE_AUDIENCE_MOTIVES = "DELETE_AUDIENCE_MOTIVES";
export const DELETE_AUDIENCE_MOTIVES_SUCCESS = "DELETE_AUDIENCE_MOTIVES_SUCCESS";
export const DELETE_AUDIENCE_MOTIVES_ERROR = "DELETE_AUDIENCE_MOTIVES_ERROR";

//AUDIENCIA RESORTEO
export const RESORTEAR_JUEZ = "RESORTEAR_JUEZ";
export const RESORTEAR_JUEZ_SUCCESS = "RESORTEAR_JUEZ_SUCCESS";
export const RESORTEAR_JUEZ_ERROR = "RESORTEAR_JUEZ_ERROR"; 

//AUDIENCIA TIPOS
export const LIST_AUDIENCE_TYPES = "LIST_AUDIENCE_TYPES";
export const LIST_AUDIENCE_TYPES_SUCCESS = "LIST_AUDIENCE_TYPES_SUCCESS";
export const LIST_AUDIENCE_TYPES_ERROR = "LIST_AUDIENCE_TYPES_ERROR";
export const ADD_AUDIENCE_TYPES = "ADD_AUDIENCE_TYPES";
export const SAVE_AUDIENCE_TYPES = "SAVE_AUDIENCE_TYPES";
export const SAVE_AUDIENCE_TYPES_SUCCESS = "SAVE_AUDIENCE_TYPES_SUCCESS";
export const SAVE_AUDIENCE_TYPES_ERROR = "SAVE_AUDIENCE_TYPES_ERROR";
export const EDIT_AUDIENCE_TYPES = "EDIT_AUDIENCE_TYPES";
export const UPDATE_AUDIENCE_TYPES = "UPDATE_AUDIENCE_TYPES";
export const UPDATE_AUDIENCE_TYPES_SUCCESS = "UPDATE_AUDIENCE_TYPES_SUCCESS";
export const UPDATE_AUDIENCE_TYPES_ERROR = "UPDATE_AUDIENCE_TYPES_ERROR";
export const DELETE_AUDIENCE_TYPES = "DELETE_AUDIENCE_TYPES";
export const DELETE_AUDIENCE_TYPES_SUCCESS = "DELETE_AUDIENCE_TYPES_SUCCESS";
export const DELETE_AUDIENCE_TYPES_ERROR = "DELETE_AUDIENCE_TYPES_ERROR";

//CHARACTERS
export const LIST_CHARACTERS = "LIST_CHARACTERS";
export const LIST_CHARACTERS_SUCCESS = "LIST_CHARACTERS_SUCCESS";
export const LIST_CHARACTERS_ERROR = "LIST_CHARACTERS_ERROR";
export const ADD_CHARACTERS = "ADD_CHARACTERS";
export const SAVE_CHARACTERS = "SAVE_CHARACTERS";
export const SAVE_CHARACTERS_SUCCESS = "SAVE_CHARACTERS_SUCCESS";
export const SAVE_CHARACTERS_ERROR = "SAVE_CHARACTERS_ERROR";
export const EDIT_CHARACTERS = "EDIT_CHARACTERS";
export const UPDATE_CHARACTERS = "UPDATE_CHARACTERS";
export const UPDATE_CHARACTERS_SUCCESS = "UPDATE_CHARACTERS_SUCCESS";
export const UPDATE_CHARACTERS_ERROR = "UPDATE_CHARACTERS_ERROR";
export const DELETE_CHARACTERS = "DELETE_CHARACTERS";
export const DELETE_CHARACTERS_SUCCESS = "DELETE_CHARACTERS_SUCCESS";
export const DELETE_CHARACTERS_ERROR = "DELETE_CHARACTERS_ERROR";

//DEFENSORIAS
export const LIST_DEFENSORIES = "LIST_DEFENSORIES";
export const LIST_DEFENSORIES_SUCCESS = "LIST_DEFENSORIES_SUCCESS";
export const LIST_DEFENSORIES_ERROR = "LIST_DEFENSORIES_ERROR";
export const ADD_DEFENSORIES = "ADD_DEFENSORIES";
export const SAVE_DEFENSORIES = "SAVE_DEFENSORIES";
export const SAVE_DEFENSORIES_SUCCESS = "SAVE_DEFENSORIES_SUCCESS";
export const SAVE_DEFENSORIES_ERROR = "SAVE_DEFENSORIES_ERROR";
export const EDIT_DEFENSORIES = "EDIT_DEFENSORIES";
export const UPDATE_DEFENSORIES = "UPDATE_DEFENSORIES";
export const UPDATE_DEFENSORIES_SUCCESS = "UPDATE_DEFENSORIES_SUCCESS";
export const UPDATE_DEFENSORIES_ERROR = "UPDATE_DEFENSORIES_ERROR";
export const DELETE_DEFENSORIES = "DELETE_DEFENSORIES";
export const DELETE_DEFENSORIES_SUCCESS = "DELETE_DEFENSORIES_SUCCESS";
export const DELETE_DEFENSORIES_ERROR = "DELETE_DEFENSORIES_ERROR";

//DEPENDENCIAS
export const LIST_DEPENDENCIES = "LIST_DEPENDENCIES";
export const LIST_DEPENDENCIES_SUCCESS = "LIST_DEPENDENCIES_SUCCESS";
export const LIST_DEPENDENCIES_ERROR = "LIST_DEPENDENCIES_ERROR";
export const ADD_DEPENDENCIES = "ADD_DEPENDENCIES";
export const SAVE_DEPENDENCIES = "SAVE_DEPENDENCIES";
export const SAVE_DEPENDENCIES_SUCCESS = "SAVE_DEPENDENCIES_SUCCESS";
export const SAVE_DEPENDENCIES_ERROR = "SAVE_DEPENDENCIES_ERROR";
export const EDIT_DEPENDENCIES = "EDIT_DEPENDENCIES";
export const UPDATE_DEPENDENCIES = "UPDATE_DEPENDENCIES";
export const UPDATE_DEPENDENCIES_SUCCESS = "UPDATE_DEPENDENCIES_SUCCESS";
export const UPDATE_DEPENDENCIES_ERROR = "UPDATE_DEPENDENCIES_ERROR";
export const DELETE_DEPENDENCIES = "DELETE_DEPENDENCIES";
export const DELETE_DEPENDENCIES_SUCCESS = "DELETE_DEPENDENCIES_SUCCESS";
export const DELETE_DEPENDENCIES_ERROR = "DELETE_DEPENDENCIES_ERROR";

//DEPENDENCIA TIPOS
export const LIST_DEPENDENCY_TYPES = "LIST_DEPENDENCY_TYPES";
export const LIST_DEPENDENCY_TYPES_SUCCESS = "LIST_DEPENDENCY_TYPES_SUCCESS";
export const LIST_DEPENDENCY_TYPES_ERROR = "LIST_DEPENDENCY_TYPES_ERROR";
export const ADD_DEPENDENCY_TYPES = "ADD_DEPENDENCY_TYPES";
export const SAVE_DEPENDENCY_TYPES = "SAVE_DEPENDENCY_TYPES";
export const SAVE_DEPENDENCY_TYPES_SUCCESS = "SAVE_DEPENDENCY_TYPES_SUCCESS";
export const SAVE_DEPENDENCY_TYPES_ERROR = "SAVE_DEPENDENCY_TYPES_ERROR";
export const EDIT_DEPENDENCY_TYPES = "EDIT_DEPENDENCY_TYPES";
export const UPDATE_DEPENDENCY_TYPES = "UPDATE_DEPENDENCY_TYPES";
export const UPDATE_DEPENDENCY_TYPES_SUCCESS = "UPDATE_DEPENDENCY_TYPES_SUCCESS";
export const UPDATE_DEPENDENCY_TYPES_ERROR = "UPDATE_DEPENDENCY_TYPES_ERROR";
export const DELETE_DEPENDENCY_TYPES = "DELETE_DEPENDENCY_TYPES";
export const DELETE_DEPENDENCY_TYPES_SUCCESS = "DELETE_DEPENDENCY_TYPES_SUCCESS";
export const DELETE_DEPENDENCY_TYPES_ERROR = "DELETE_DEPENDENCY_TYPES_ERROR";

//FUNCTIONARIES
export const LIST_FUNCTIONARIES = "LIST_FUNCTIONARIES";
export const LIST_FUNCTIONARIES_SUCCESS = "LIST_FUNCTIONARIES_SUCCESS";
export const LIST_FUNCTIONARIES_ERROR = "LIST_FUNCTIONARIES_ERROR";
export const ADD_FUNCTIONARIES = "ADD_FUNCTIONARIES";
export const SAVE_FUNCTIONARIES = "SAVE_FUNCTIONARIES";
export const SAVE_FUNCTIONARIES_SUCCESS = "SAVE_FUNCTIONARIES_SUCCESS";
export const SAVE_FUNCTIONARIES_ERROR = "SAVE_FUNCTIONARIES_ERROR";
export const EDIT_FUNCTIONARIES = "EDIT_FUNCTIONARIES";
export const UPDATE_FUNCTIONARIES = "UPDATE_FUNCTIONARIES";
export const UPDATE_FUNCTIONARIES_SUCCESS = "UPDATE_FUNCTIONARIES_SUCCESS";
export const UPDATE_FUNCTIONARIES_ERROR = "UPDATE_FUNCTIONARIES_ERROR";
export const ENABLE_FUNCTIONARIES = "ENABLE_FUNCTIONARIES";
export const ENABLE_FUNCTIONARIES_SUCCESS = "ENABLE_FUNCTIONARIES_SUCCESS";
export const ENABLE_FUNCTIONARIES_ERROR = "ENABLE_FUNCTIONARIES_ERROR";
export const DELETE_FUNCTIONARIES = "DELETE_FUNCTIONARIES";
export const DELETE_FUNCTIONARIES_SUCCESS = "DELETE_FUNCTIONARIES_SUCCESS";
export const DELETE_FUNCTIONARIES_ERROR = "DELETE_FUNCTIONARIES_ERROR";

//FUNCTIONARY TYPES
export const LIST_FUNCTIONARY_TYPES = "LIST_FUNCTIONARY_TYPES";
export const LIST_FUNCTIONARY_TYPES_SUCCESS = "LIST_FUNCTIONARY_TYPES_SUCCESS";
export const LIST_FUNCTIONARY_TYPES_ERROR = "LIST_FUNCTIONARY_TYPES_ERROR";

//INHIBITIONS
export const LIST_INHIBITIONS = "LIST_INHIBITIONS";
export const LIST_INHIBITIONS_SUCCESS = "LIST_INHIBITIONS_SUCCESS";
export const LIST_INHIBITIONS_ERROR = "LIST_INHIBITIONS_ERROR";
export const ADD_INHIBITIONS = "ADD_INHIBITIONS";
export const SAVE_INHIBITIONS = "SAVE_INHIBITIONS";
export const SAVE_INHIBITIONS_SUCCESS = "SAVE_INHIBITIONS_SUCCESS";
export const SAVE_INHIBITIONS_ERROR = "SAVE_INHIBITIONS_ERROR";
export const EDIT_INHIBITIONS = "EDIT_INHIBITIONS";
export const UPDATE_INHIBITIONS = "UPDATE_INHIBITIONS";
export const UPDATE_INHIBITIONS_SUCCESS = "UPDATE_INHIBITIONS_SUCCESS";
export const UPDATE_INHIBITIONS_ERROR = "UPDATE_INHIBITIONS_ERROR";
export const DELETE_INHIBITIONS = "DELETE_INHIBITIONS";
export const DELETE_INHIBITIONS_SUCCESS = "DELETE_INHIBITIONS_SUCCESS";
export const DELETE_INHIBITIONS_ERROR = "DELETE_INHIBITIONS_ERROR";

//INHIBICION TIPOS
export const LIST_INHIBITION_TYPES = "LIST_INHIBITION_TYPES";
export const LIST_INHIBITION_TYPES_SUCCESS = "LIST_INHIBITION_TYPES_SUCCESS";
export const LIST_INHIBITION_TYPES_ERROR = "LIST_INHIBITION_TYPES_ERROR";
export const ADD_INHIBITION_TYPES = "ADD_INHIBITION_TYPES";
export const SAVE_INHIBITION_TYPES = "SAVE_INHIBITION_TYPES";
export const SAVE_INHIBITION_TYPES_SUCCESS = "SAVE_INHIBITION_TYPES_SUCCESS";
export const SAVE_INHIBITION_TYPES_ERROR = "SAVE_INHIBITION_TYPES_ERROR";
export const EDIT_INHIBITION_TYPES = "EDIT_INHIBITION_TYPES";
export const UPDATE_INHIBITION_TYPES = "UPDATE_INHIBITION_TYPES";
export const UPDATE_INHIBITION_TYPES_SUCCESS = "UPDATE_INHIBITION_TYPES_SUCCESS";
export const UPDATE_INHIBITION_TYPES_ERROR = "UPDATE_INHIBITION_TYPES_ERROR";
export const DELETE_INHIBITION_TYPES = "DELETE_INHIBITION_TYPES";
export const DELETE_INHIBITION_TYPES_SUCCESS = "DELETE_INHIBITION_TYPES_SUCCESS";
export const DELETE_INHIBITION_TYPES_ERROR = "DELETE_INHIBITION_TYPES_ERROR";

//INTERMEDIATES
export const LIST_INTERMEDIATES = "LIST_INTERMEDIATES";
export const LIST_INTERMEDIATES_SUCCESS = "LIST_INTERMEDIATES_SUCCESS";
export const LIST_INTERMEDIATES_ERROR = "LIST_INTERMEDIATES_ERROR";
export const ADD_INTERMEDIATES = "ADD_INTERMEDIATES";
export const SAVE_INTERMEDIATES = "SAVE_INTERMEDIATES";
export const SAVE_INTERMEDIATES_SUCCESS = "SAVE_INTERMEDIATES_SUCCESS";
export const SAVE_INTERMEDIATES_ERROR = "SAVE_INTERMEDIATES_ERROR";
export const EDIT_INTERMEDIATES = "EDIT_INTERMEDIATES";
export const UPDATE_INTERMEDIATES = "UPDATE_INTERMEDIATES";
export const UPDATE_INTERMEDIATES_SUCCESS = "UPDATE_INTERMEDIATES_SUCCESS";
export const UPDATE_INTERMEDIATES_ERROR = "UPDATE_INTERMEDIATES_ERROR";
export const DELETE_INTERMEDIATES = "DELETE_INTERMEDIATES";
export const DELETE_INTERMEDIATES_SUCCESS = "DELETE_INTERMEDIATES_SUCCESS";
export const DELETE_INTERMEDIATES_ERROR = "DELETE_INTERMEDIATES_ERROR";

//JUDGES
export const LIST_JUDGES = "LIST_JUDGES";
export const LIST_JUDGES_SUCCESS = "LIST_JUDGES_SUCCESS";
export const LIST_JUDGES_ERROR = "LIST_JUDGES_ERROR";
export const ADD_JUDGES = "ADD_JUDGES";
export const SAVE_JUDGES = "SAVE_JUDGES";
export const SAVE_JUDGES_SUCCESS = "SAVE_JUDGES_SUCCESS";
export const SAVE_JUDGES_ERROR = "SAVE_JUDGES_ERROR";
export const EDIT_JUDGES = "EDIT_JUDGES";
export const UPDATE_JUDGES = "UPDATE_JUDGES";
export const UPDATE_JUDGES_SUCCESS = "UPDATE_JUDGES_SUCCESS";
export const UPDATE_JUDGES_ERROR = "UPDATE_JUDGES_ERROR";
export const ENABLE_JUDGES = "ENABLE_JUDGES";
export const ENABLE_JUDGES_SUCCESS = "ENABLE_JUDGES_SUCCESS";
export const ENABLE_JUDGES_ERROR = "ENABLE_JUDGES_ERROR";
export const DELETE_JUDGES = "DELETE_JUDGES";
export const DELETE_JUDGES_SUCCESS = "DELETE_JUDGES_SUCCESS";
export const DELETE_JUDGES_ERROR = "DELETE_JUDGES_ERROR";

//LEVELS
export const LIST_LEVELS = "LIST_LEVELS";
export const LIST_LEVELS_SUCCESS = "LIST_LEVELS_SUCCESS";
export const LIST_LEVELS_ERROR = "LIST_LEVELS_ERROR";
export const ADD_LEVELS = "ADD_LEVELS";
export const SAVE_LEVELS = "SAVE_LEVELS";
export const SAVE_LEVELS_SUCCESS = "SAVE_LEVELS_SUCCESS";
export const SAVE_LEVELS_ERROR = "SAVE_LEVELS_ERROR";
export const EDIT_LEVELS = "EDIT_LEVELS";
export const UPDATE_LEVELS = "UPDATE_LEVELS";
export const UPDATE_LEVELS_SUCCESS = "UPDATE_LEVELS_SUCCESS";
export const UPDATE_LEVELS_ERROR = "UPDATE_LEVELS_ERROR";
export const DELETE_LEVELS = "DELETE_LEVELS";
export const DELETE_LEVELS_SUCCESS = "DELETE_LEVELS_SUCCESS";
export const DELETE_LEVELS_ERROR = "DELETE_LEVELS_ERROR";

//LICENCES
export const LIST_LICENCES = "LIST_LICENCES";
export const LIST_LICENCES_SUCCESS = "LIST_LICENCES_SUCCESS";
export const LIST_LICENCES_ERROR = "LIST_LICENCES_ERROR";
export const ADD_LICENCES = "ADD_LICENCES";
export const SAVE_LICENCES = "SAVE_LICENCES";
export const SAVE_LICENCES_SUCCESS = "SAVE_LICENCES_SUCCESS";
export const SAVE_LICENCES_ERROR = "SAVE_LICENCES_ERROR";
export const EDIT_LICENCES = "EDIT_LICENCES";
export const UPDATE_LICENCES = "UPDATE_LICENCES";
export const UPDATE_LICENCES_SUCCESS = "UPDATE_LICENCES_SUCCESS";
export const UPDATE_LICENCES_ERROR = "UPDATE_LICENCES_ERROR";
export const DELETE_LICENCES = "DELETE_LICENCES";
export const DELETE_LICENCES_SUCCESS = "DELETE_LICENCES_SUCCESS";
export const DELETE_LICENCES_ERROR = "DELETE_LICENCES_ERROR";

//LICENCE TYPES
export const LIST_LICENCE_TYPES = "LIST_LICENCE_TYPES";
export const LIST_LICENCE_TYPES_SUCCESS = "LIST_LICENCE_TYPES_SUCCESS";
export const LIST_LICENCE_TYPES_ERROR = "LIST_LICENCE_TYPES_ERROR";
export const ADD_LICENCE_TYPES = "ADD_LICENCE_TYPES";
export const SAVE_LICENCE_TYPES = "SAVE_LICENCE_TYPES";
export const SAVE_LICENCE_TYPES_SUCCESS = "SAVE_LICENCE_TYPES_SUCCESS";
export const SAVE_LICENCE_TYPES_ERROR = "SAVE_LICENCE_TYPES_ERROR";
export const EDIT_LICENCE_TYPES = "EDIT_LICENCE_TYPES";
export const UPDATE_LICENCE_TYPES = "UPDATE_LICENCE_TYPES";
export const UPDATE_LICENCE_TYPES_SUCCESS = "UPDATE_LICENCE_TYPES_SUCCESS";
export const UPDATE_LICENCE_TYPES_ERROR = "UPDATE_LICENCE_TYPES_ERROR";
export const DELETE_LICENCE_TYPES = "DELETE_LICENCE_TYPES";
export const DELETE_LICENCE_TYPES_SUCCESS = "DELETE_LICENCE_TYPES_SUCCESS";
export const DELETE_LICENCE_TYPES_ERROR = "DELETE_LICENCE_TYPES_ERROR";

//MODELOS
export const LIST_MODELOS = "LIST_MODELOS";
export const LIST_MODELOS_SUCCESS = "LIST_MODELOS_SUCCESS";
export const LIST_MODELOS_ERROR = "LIST_MODELOS_ERROR";

//NOTIFICATIONS
export const LIST_NOTIFICATIONS = "LIST_NOTIFICATIONS";
export const LIST_NOTIFICATIONS_SUCCESS = "LIST_NOTIFICATIONS_SUCCESS";
export const LIST_NOTIFICATIONS_ERROR = "LIST_NOTIFICATIONS_ERROR";
export const ADD_NOTIFICATIONS = "ADD_NOTIFICATIONS";
export const SAVE_NOTIFICATIONS = "SAVE_NOTIFICATIONS";
export const SAVE_NOTIFICATIONS_SUCCESS = "SAVE_NOTIFICATIONS_SUCCESS";
export const SAVE_NOTIFICATIONS_ERROR = "SAVE_NOTIFICATIONS_ERROR";
export const EDIT_NOTIFICATIONS = "EDIT_NOTIFICATIONS";
export const UPDATE_NOTIFICATIONS = "UPDATE_NOTIFICATIONS";
export const UPDATE_NOTIFICATIONS_SUCCESS = "UPDATE_NOTIFICATIONS_SUCCESS";
export const UPDATE_NOTIFICATIONS_ERROR = "UPDATE_NOTIFICATIONS_ERROR";
export const DELETE_NOTIFICATIONS = "DELETE_NOTIFICATIONS";
export const DELETE_NOTIFICATIONS_SUCCESS = "DELETE_NOTIFICATIONS_SUCCESS";
export const DELETE_NOTIFICATIONS_ERROR = "DELETE_NOTIFICATIONS_ERROR";

//NOTIFICATION TYPES
export const LIST_NOTIFICATION_TYPES = "LIST_NOTIFICATION_TYPES";
export const LIST_NOTIFICATION_TYPES_SUCCESS = "LIST_NOTIFICATION_TYPES_SUCCESS";
export const LIST_NOTIFICATION_TYPES_ERROR = "LIST_NOTIFICATION_TYPES_ERROR";

//OBJECTS
export const LIST_OBJECTS = "LIST_OBJECTS";
export const LIST_OBJECTS_SUCCESS = "LIST_OBJECTS_SUCCESS";
export const LIST_OBJECTS_ERROR = "LIST_OBJECTS_ERROR";

//OFIJUS
export const LIST_OFIJUS = "LIST_OFIJUS";
export const LIST_OFIJUS_SUCCESS = "LIST_OFIJUS_SUCCESS";
export const LIST_OFIJUS_ERROR = "LIST_OFIJUS_ERROR";
export const ADD_OFIJUS = "ADD_OFIJUS";
export const SAVE_OFIJUS = "SAVE_OFIJUS";
export const SAVE_OFIJUS_SUCCESS = "SAVE_OFIJUS_SUCCESS";
export const SAVE_OFIJUS_ERROR = "SAVE_OFIJUS_ERROR";
export const EDIT_OFIJUS = "EDIT_OFIJUS";
export const UPDATE_OFIJUS = "UPDATE_OFIJUS";
export const UPDATE_OFIJUS_SUCCESS = "UPDATE_OFIJUS_SUCCESS";
export const UPDATE_OFIJUS_ERROR = "UPDATE_OFIJUS_ERROR";
export const DELETE_OFIJUS = "DELETE_OFIJUS";
export const DELETE_OFIJUS_SUCCESS = "DELETE_OFIJUS_SUCCESS";
export const DELETE_OFIJUS_ERROR = "DELETE_OFIJUS_ERROR";

//PERSONAS
export const LIST_PERSONAS = "LIST_PERSONAS";
export const LIST_PERSONAS_SUCCESS = "LIST_PERSONAS_SUCCESS";
export const LIST_PERSONAS_ERROR = "LIST_PERSONAS_ERROR";

//PERSONA TIPOS
export const LIST_PERSON_TYPES = "LIST_PERSON_TYPES";
export const LIST_PERSON_TYPES_SUCCESS = "LIST_PERSON_TYPES_SUCCESS";
export const LIST_PERSON_TYPES_ERROR = "LIST_PERSON_TYPES_ERROR";
export const ADD_PERSON_TYPES = "ADD_PERSON_TYPES";
export const SAVE_PERSON_TYPES = "SAVE_PERSON_TYPES";
export const SAVE_PERSON_TYPES_SUCCESS = "SAVE_PERSON_TYPES_SUCCESS";
export const SAVE_PERSON_TYPES_ERROR = "SAVE_PERSON_TYPES_ERROR";
export const EDIT_PERSON_TYPES = "EDIT_PERSON_TYPES";
export const UPDATE_PERSON_TYPES = "UPDATE_PERSON_TYPES";
export const UPDATE_PERSON_TYPES_SUCCESS = "UPDATE_PERSON_TYPES_SUCCESS";
export const UPDATE_PERSON_TYPES_ERROR = "UPDATE_PERSON_TYPES_ERROR";
export const DELETE_PERSON_TYPES = "DELETE_PERSON_TYPES";
export const DELETE_PERSON_TYPES_SUCCESS = "DELETE_PERSON_TYPES_SUCCESS";
export const DELETE_PERSON_TYPES_ERROR = "DELETE_PERSON_TYPES_ERROR";

//PRIORIDADES
export const LIST_PRIORIDADES = "LIST_PRIORIDADES";
export const LIST_PRIORIDADES_SUCCESS = "LIST_PRIORIDADES_SUCCESS";
export const LIST_PRIORIDADES_ERROR = "LIST_PRIORIDADES_ERROR";

//RECUSES
export const LIST_RECUSES = "LIST_RECUSES";
export const LIST_RECUSES_SUCCESS = "LIST_RECUSES_SUCCESS";
export const LIST_RECUSES_ERROR = "LIST_RECUSES_ERROR";
export const ADD_RECUSES = "ADD_RECUSES";
export const SAVE_RECUSES = "SAVE_RECUSES";
export const SAVE_RECUSES_SUCCESS = "SAVE_RECUSES_SUCCESS";
export const SAVE_RECUSES_ERROR = "SAVE_RECUSES_ERROR";
export const EDIT_RECUSES = "EDIT_RECUSES";
export const UPDATE_RECUSES = "UPDATE_RECUSES";
export const UPDATE_RECUSES_SUCCESS = "UPDATE_RECUSES_SUCCESS";
export const UPDATE_RECUSES_ERROR = "UPDATE_RECUSES_ERROR";
export const DELETE_RECUSES = "DELETE_RECUSES";
export const DELETE_RECUSES_SUCCESS = "DELETE_RECUSES_SUCCESS";
export const DELETE_RECUSES_ERROR = "DELETE_RECUSES_ERROR";

//RESULTADO MODALIDADES
export const LIST_RESULT_MODALITIES = "LIST_RESULT_MODALITIES";
export const LIST_RESULT_MODALITIES_SUCCESS = "LIST_RESULT_MODALITIES_SUCCESS";
export const LIST_RESULT_MODALITIES_ERROR = "LIST_RESULT_MODALITIES_ERROR";
export const ADD_RESULT_MODALITIES = "ADD_RESULT_MODALITIES";
export const SAVE_RESULT_MODALITIES = "SAVE_RESULT_MODALITIES";
export const SAVE_RESULT_MODALITIES_SUCCESS = "SAVE_RESULT_MODALITIES_SUCCESS";
export const SAVE_RESULT_MODALITIES_ERROR = "SAVE_RESULT_MODALITIES_ERROR";
export const EDIT_RESULT_MODALITIES = "EDIT_RESULT_MODALITIES";
export const UPDATE_RESULT_MODALITIES = "UPDATE_RESULT_MODALITIES";
export const UPDATE_RESULT_MODALITIES_SUCCESS = "UPDATE_RESULT_MODALITIES_SUCCESS";
export const UPDATE_RESULT_MODALITIES_ERROR = "UPDATE_RESULT_MODALITIES_ERROR";
export const DELETE_RESULT_MODALITIES = "DELETE_RESULT_MODALITIES";
export const DELETE_RESULT_MODALITIES_SUCCESS = "DELETE_RESULT_MODALITIES_SUCCESS";
export const DELETE_RESULT_MODALITIES_ERROR = "DELETE_RESULT_MODALITIES_ERROR";

//RESULTADO TIPOS
export const LIST_RESULT_TYPES = "LIST_RESULT_TYPES";
export const LIST_RESULT_TYPES_SUCCESS = "LIST_RESULT_TYPES_SUCCESS";
export const LIST_RESULT_TYPES_ERROR = "LIST_RESULT_TYPES_ERROR";
export const ADD_RESULT_TYPES = "ADD_RESULT_TYPES";
export const SAVE_RESULT_TYPES = "SAVE_RESULT_TYPES";
export const SAVE_RESULT_TYPES_SUCCESS = "SAVE_RESULT_TYPES_SUCCESS";
export const SAVE_RESULT_TYPES_ERROR = "SAVE_RESULT_TYPES_ERROR";
export const EDIT_RESULT_TYPES = "EDIT_RESULT_TYPES";
export const UPDATE_RESULT_TYPES = "UPDATE_RESULT_TYPES";
export const UPDATE_RESULT_TYPES_SUCCESS = "UPDATE_RESULT_TYPES_SUCCESS";
export const UPDATE_RESULT_TYPES_ERROR = "UPDATE_RESULT_TYPES_ERROR";
export const DELETE_RESULT_TYPES = "DELETE_RESULT_TYPES";
export const DELETE_RESULT_TYPES_SUCCESS = "DELETE_RESULT_TYPES_SUCCESS";
export const DELETE_RESULT_TYPES_ERROR = "DELETE_RESULT_TYPES_ERROR";

//SALAS
export const LIST_ROOMS = "LIST_ROOMS";
export const LIST_ROOMS_SUCCESS = "LIST_ROOMS_SUCCESS";
export const LIST_ROOMS_ERROR = "LIST_ROOMS_ERROR";
export const ADD_ROOMS = "ADD_ROOMS";
export const SAVE_ROOMS = "SAVE_ROOMS";
export const SAVE_ROOMS_SUCCESS = "SAVE_ROOMS_SUCCESS";
export const SAVE_ROOMS_ERROR = "SAVE_ROOMS_ERROR";
export const EDIT_ROOMS = "EDIT_ROOMS";
export const UPDATE_ROOMS = "UPDATE_ROOMS";
export const UPDATE_ROOMS_SUCCESS = "UPDATE_ROOMS_SUCCESS";
export const UPDATE_ROOMS_ERROR = "UPDATE_ROOMS_ERROR";
export const DELETE_ROOMS = "DELETE_ROOMS";
export const DELETE_ROOMS_SUCCESS = "DELETE_ROOMS_SUCCESS";
export const DELETE_ROOMS_ERROR = "DELETE_ROOMS_ERROR";

//SERVIDORES
export const LIST_SERVERS = "LIST_SERVERS";
export const LIST_SERVERS_SUCCESS = "LIST_SERVERS_SUCCESS";
export const LIST_SERVERS_ERROR = "LIST_SERVERS_ERROR";
export const ADD_SERVERS = "ADD_SERVERS";
export const SAVE_SERVERS = "SAVE_SERVERS";
export const SAVE_SERVERS_SUCCESS = "SAVE_SERVERS_SUCCESS";
export const SAVE_SERVERS_ERROR = "SAVE_SERVERS_ERROR";
export const EDIT_SERVERS = "EDIT_SERVERS";
export const UPDATE_SERVERS = "UPDATE_SERVERS";
export const UPDATE_SERVERS_SUCCESS = "UPDATE_SERVERS_SUCCESS";
export const UPDATE_SERVERS_ERROR = "UPDATE_SERVERS_ERROR";
export const DELETE_SERVERS = "DELETE_SERVERS";
export const DELETE_SERVERS_SUCCESS = "DELETE_SERVERS_SUCCESS";
export const DELETE_SERVERS_ERROR = "DELETE_SERVERS_ERROR";

//SYSTEM
export const MENU_EXPAND = "MENU_EXPAND";
export const MENU_EXPAND_SUCCESS = "MENU_EXPAND_SUCCESS";
export const MENU_EXPAND_ERROR = "MENU_EXPAND_ERROR";
export const MENU_COLLAPSE = "MENU_COLLAPSE";
export const MENU_COLLAPSE_SUCCESS = "MENU_COLLAPSE_SUCCESS";
export const MENU_COLLAPSE_ERROR = "MENU_COLLAPSE_ERROR";

//TURNS
export const LIST_TURNS = "LIST_TURNS";
export const LIST_TURNS_SUCCESS = "LIST_TURNS_SUCCESS";
export const LIST_TURNS_ERROR = "LIST_TURNS_ERROR";
export const ADD_TURNS = "ADD_TURNS";
export const SAVE_TURNS = "SAVE_TURNS";
export const SAVE_TURNS_SUCCESS = "SAVE_TURNS_SUCCESS";
export const SAVE_TURNS_ERROR = "SAVE_TURNS_ERROR";
export const EDIT_TURNS = "EDIT_TURNS";
export const UPDATE_TURNS = "UPDATE_TURNS";
export const UPDATE_TURNS_SUCCESS = "UPDATE_TURNS_SUCCESS";
export const UPDATE_TURNS_ERROR = "UPDATE_TURNS_ERROR";
export const DELETE_TURNS = "DELETE_TURNS";
export const DELETE_TURNS_SUCCESS = "DELETE_TURNS_SUCCESS";
export const DELETE_TURNS_ERROR = "DELETE_TURNS_ERROR";

//UNITS
export const LIST_UNITS = "LIST_UNITS";
export const LIST_UNITS_SUCCESS = "LIST_UNITS_SUCCESS";
export const LIST_UNITS_ERROR = "LIST_UNITS_ERROR";
export const ADD_UNITS = "ADD_UNITS";
export const SAVE_UNITS = "SAVE_UNITS";
export const SAVE_UNITS_SUCCESS = "SAVE_UNITS_SUCCESS";
export const SAVE_UNITS_ERROR = "SAVE_UNITS_ERROR";
export const EDIT_UNITS = "EDIT_UNITS";
export const UPDATE_UNITS = "UPDATE_UNITS";
export const UPDATE_UNITS_SUCCESS = "UPDATE_UNITS_SUCCESS";
export const UPDATE_UNITS_ERROR = "UPDATE_UNITS_ERROR";
export const DELETE_UNITS = "DELETE_UNITS";
export const DELETE_UNITS_SUCCESS = "DELETE_UNITS_SUCCESS";
export const DELETE_UNITS_ERROR = "DELETE_UNITS_ERROR";

//USERS
export const LIST_USERS = "LIST_USERS";
export const LIST_USERS_SUCCESS = "LIST_USERS_SUCCESS";
export const LIST_USERS_ERROR = "LIST_USERS_ERROR";
export const ADD_USERS = "ADD_USERS";
export const SAVE_USERS = "SAVE_USERS";
export const SAVE_USERS_SUCCESS = "SAVE_USERS_SUCCESS";
export const SAVE_USERS_ERROR = "SAVE_USERS_ERROR";
export const EDIT_USERS = "EDIT_USERS";
export const UPDATE_USERS = "UPDATE_USERS";
export const UPDATE_USERS_SUCCESS = "UPDATE_USERS_SUCCESS";
export const UPDATE_USERS_ERROR = "UPDATE_USERS_ERROR";
export const ENABLE_USERS = "ENABLE_USERS";
export const ENABLE_USERS_SUCCESS = "ENABLE_USERS_SUCCESS";
export const ENABLE_USERS_ERROR = "ENABLE_USERS_ERROR";
export const DELETE_USERS = "DELETE_USERS";
export const DELETE_USERS_SUCCESS = "DELETE_USERS_SUCCESS";
export const DELETE_USERS_ERROR = "DELETE_USERS_ERROR";

export const GET_RESET_PASS_TOKEN = "GET_RESET_PASS_TOKEN";
export const GET_RESET_PASS_TOKEN_SUCCESS = "GET_RESET_PASS_TOKEN_SUCCESS";
export const GET_RESET_PASS_TOKEN_ERROR = "GET_RESET_PASS_TOKEN_ERROR";
export const RESET_PASS_USERS = "RESET_PASS_USERS";
export const RESET_PASS_USERS_SUCCESS = "RESET_PASS_USERS_SUCCESS";
export const RESET_PASS_USERS_ERROR = "RESET_PASS_USERS_ERROR";
export const RESET_PASS_TOKEN = "RESET_PASS_TOKEN";
export const RESET_PASS_TOKEN_SUCCESS = "RESET_PASS_TOKEN_SUCCESS";
export const RESET_PASS_TOKEN_ERROR = "RESET_PASS_TOKEN_ERROR";
